/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

function closeSubmenu(el) {
  if (el.classList.contains('SubSub_close')) {
    const parent = document.querySelectorAll(".custom-mobile-nav__link[aria-expanded=true]")
    const collapsible = parent[1].parentNode
    const inner = parent[1].nextElementSibling
    parent[1].setAttribute("aria-expanded", "false")
    collapsible.style.overflow = "hidden"
    inner.style.overflow = "hidden"
  } else {
      const parent = document.querySelector(".custom-mobile-nav__link[aria-expanded=true]")
      const collapsible = parent.parentNode
      const inner = parent.nextElementSibling
      parent.setAttribute("aria-expanded", "false")
      collapsible.style.overflow = "hidden"
      inner.style.overflow = "hidden"
  }
}

function checkErrors(e) {
  const form = document.querySelector('.shopify-product-form')
  const error = document.querySelector('#main-product-error')
  const first_file = document.querySelector(".shopify-product-form .option-type-file input")
  
  if (first_file != null) {
    const y = first_file.offsetTop
    if (first_file.value.length < 1) {
      error.style.display = 'block'
      window.scrollTo({top: y, behavior: 'smooth'});
    }  
  }
}

function checkGiftboxErrors(e, el) {
  console.log(e.target)
  const variant = el.getAttribute('data-variant')
  const form = document.querySelector('#form-' + variant)
  const error = document.querySelector('#error-' + variant)
  const first_file = document.querySelectorAll('#form-' + variant + ' input[type="file"]')[0]

  if (first_file != null) {
    if (first_file.value.length < 1) {
      error.style.display = 'block'
    }  
  }
}

function toggleGiftbox() {
  const gift_modal = document.querySelector('#giftbox-popup')
  if (gift_modal)
    gift_modal.open = true
}

function toggleCartGift(evt) {
  evt.preventDefault()
  const gift_modal = document.querySelector('#giftbox-popup')
  if (gift_modal)
    gift_modal.open = true
  const modal_overlay = document.querySelector('#giftbox-popup .modal__overlay')
  if (modal_overlay)
    modal_overlay.addEventListener('click', () => {
      window.location.href ='/checkout';
    })

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      window.location.href ='/checkout';
    }
  });
}

function toggleGiftboxProperties(el) {
  const collapsed = document.querySelector('#collapse_' + el.getAttribute('data-product'))
  const blocked = document.querySelector('#giftbox__block--' + el.getAttribute('data-product'))
  
  if (collapsed.classList.contains('open')) {
    collapsed.classList.remove('open')
    blocked.classList.remove('errored')
  } else {
      if (el.getAttribute('data-product') == '30391707533396') {
        const other_box = document.querySelector('#checkbox-3')
        if (other_box.checked) {
          document.querySelector('#collapse_45605711937753').classList.remove('open')
          other_box.checked = false
        }
      }   
      else if (el.getAttribute('data-product') == '45605711937753') {
        const other_box = document.querySelector('#checkbox-2')
        if (other_box.checked)
          other_box.checked = false
        collapsed.classList.add('open')
      } else 
        collapsed.classList.add('open')
  }
}

const cart_giftbox = document.querySelector('.cart-giftbox')
if(cart_giftbox) {
  cart_giftbox.addEventListener('click', () => {
    window.location.href ='/checkout';
  })
}

const product_form = document.querySelector('.product-form__buy-buttons .shopify-product-form')
if (product_form) {
  product_form.addEventListener('submit', interceptGpoAdd)
}
function interceptGpoAdd(event) {

  
}


/* === Andi accessibility widget cursor:pointer leak fix (added 2026-04-30) ===
 * The Andi widget (system.user-a.co.il) sets role="button", tabindex="0",
 * and cursor:pointer on the <html> element by mistake — its button-promotion
 * heuristic over-matches the document root. Mitigations:
 *   1. CSS rule neutralises the visible cursor.
 *   2. Pre-set role="document" + andialreadysetasbtn so Andi's own guards skip.
 *   3. MutationObserver as a safety net for paths that bypass the guards.
 * Remove once Andi patches upstream (ticket: TODO).
 */
(function () {
  var fixRoot = function () {
    var h = document.documentElement;
    if (h.getAttribute('role') !== 'document') h.setAttribute('role', 'document');
    if (h.getAttribute('andialreadysetasbtn') !== '1') h.setAttribute('andialreadysetasbtn', '1');
    if (h.hasAttribute('tabindex')) h.removeAttribute('tabindex');
  };
  var s = document.createElement('style');
  s.setAttribute('data-andi-cursor-fix', '');
  s.textContent = 'html[style*="cursor"]{cursor:auto !important}';
  (document.head || document.documentElement).appendChild(s);
  fixRoot();
  document.addEventListener('DOMContentLoaded', fixRoot);
  window.addEventListener('load', function () {
    setTimeout(fixRoot, 0);
    setTimeout(fixRoot, 1500);
    setTimeout(fixRoot, 4000);
  });
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function () { fixRoot(); }).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['tabindex', 'role']
    });
  }
})();
/* === end Andi fix === */
